<script lang="ts">
    import { mdiArrowDecisionAuto } from "@mdi/js"
    import { _ } from "svelte-i18n"
    import { createEventDispatcher, tick } from "svelte"
    import Icon from "../../widgets/Icon.svelte"

    import PositionAttachments from "./PositionAttachments.svelte"
    import PositionConnectionsList from "./PositionConnectionsList.svelte"
    import PositionText from "./PositionText.svelte"
    import { login } from "../../../store"
    import { hasOpOutPermission, isAdmin } from "../../../../../api/hooks/config-client"

    export let operation: Operation | OperationOut
    export let position: OperationPosition
    export let loadAttachments: (op: Operation | OperationOut) => Promise<Attachement[]>
    export let sharedView: boolean = false

    export let activeTab: "text" | "connected" | "connectedOut" = null

    const dispatch = createEventDispatcher()

    let container: HTMLElement
    let _clientHeight: number
    export let clientHeight: number
    function setHeight(h: number) {
        clientHeight = h
        window.setTimeout(() => {
            tick().then(() => {
                const delayedHeight = container?.clientHeight
                if (delayedHeight && clientHeight != delayedHeight) {
                    clientHeight = delayedHeight
                }
            })
        }, 10)
    }
    $: setHeight(_clientHeight)
</script>

<div class="hiddeninfos_header">
    <div class="title">
        {operation.type == 1 ? $_("positions.offerNumber") : $_("positions.orderNumber")}
        {operation.number} / {$_("positions.position")}
        {position.number}
        {#if position.alternativeTo}
            <span style="padding-left: 20px">
                <Icon path="{mdiArrowDecisionAuto}" />{$_("positions.alternativeTo")}
                {position.alternativeTo}
            </span>
        {/if}
    </div>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div
        class="close"
        on:click="{() => {
            dispatch('close')
        }}"
    >
        <svg width="24px" height="24px" viewBox="0 0 24 24"
            ><path
                d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
                fill="currentColor"
            ></path></svg
        >
    </div>
</div>
<div class="hiddeninfos_inner" bind:clientHeight="{_clientHeight}" bind:this="{container}">
    <div class="tabnav">
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div
            class="item"
            class:active="{!activeTab}"
            on:click="{() => {
                activeTab = null
            }}"
        >
            {$_("positions.fileAttachements")}
        </div>
        {#if !sharedView && ((operation.type == 2 && operation.collectionName !== "operation-out") || operation.type == 1)}
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <!-- svelte-ignore a11y-no-static-element-interactions -->
            <div
                class="item"
                class:active="{activeTab == 'connected'}"
                on:click="{() => {
                    activeTab = 'connected'
                }}"
            >
                {$_("positions.linkedIncomingOperations")}
            </div>
        {/if}
        {#if !sharedView && operation.collectionName !== "operation-out" && (isAdmin($login) || hasOpOutPermission($login))}
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <!-- svelte-ignore a11y-no-static-element-interactions -->
            <div
                class="item"
                class:active="{activeTab == 'connectedOut'}"
                on:click="{() => {
                    activeTab = 'connectedOut'
                }}"
            >
                {$_("positions.linkedOutgoingOperations")}
            </div>
        {/if}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div
            class="item"
            class:active="{activeTab == 'text'}"
            on:click="{() => {
                activeTab = 'text'
            }}"
        >
            {$_("positions.texts")}
        </div>
    </div>
    <div class="tabcontent">
        {#if position?.preLetter}
            <div class="positionstexte">
                <h3>{$_("positions.positionCoverLetter")}</h3>
            </div>
            <div class="positionstext">
                {@html position.preLetter}
            </div>

            <br /><br />
        {/if}
        {#if !activeTab}
            <PositionAttachments {operation} {position} {loadAttachments} />
        {:else if activeTab == "connected"}
            <PositionConnectionsList {operation} {position} />
        {:else if activeTab == "connectedOut"}
            <PositionConnectionsList {operation} {position} connectionsExit="{true}" />
        {:else if activeTab == "text"}
            <div class="positionstexte">
                <h3>{$_("positions.positionsTexts")}</h3>
            </div>
            <div class="positionstext">
                <PositionText {position} />
            </div>
        {/if}
    </div>
</div>
